import { ADD_MUSIC_PLAYLIST, ADD_PLAYLIST, ADD_TO_PLAYLIST, SELECTED_ADD_PLAYLIST } from "../types/music";

export const addPlaylist = (name, navigate) => (dispatch) => {
  const createRef = name.replace(/ /g, "").toLowerCase();

  dispatch({
    type: ADD_PLAYLIST,
    payload: {
      ref: createRef,
      name: name,
    },
  });

  navigate && navigate(`/playlist/${createRef}`);
};

export const setselectedAddPlaylist = (music) => (dispatch) => {
  dispatch({
    type: SELECTED_ADD_PLAYLIST,
    payload: music,
  });
};

export const addToPlaylist = (refs, music) => (dispatch, getState) => {
  const getPlaylistCopy = JSON.parse(JSON.stringify(getState().music.playlistMusic));

  refs.forEach((ref) => {
    let musicExists = false;
    getPlaylistCopy[ref].music.forEach((playlistMusic) => {
      if (playlistMusic.name === music.name) {
        musicExists = true;
      }
    });
    if (musicExists) {
    } else {
      dispatch({
        type: ADD_TO_PLAYLIST,
        payload: {
          ref,
          music,
        },
      });
    }
  });
};
